/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

export const RECEIVED_SERVER_PING = 'RECEIVED_SERVER_PING';
export const receivedServerPing = (info) => ({
  type: RECEIVED_SERVER_PING,
  info
});

export const ERROR_SERVER_PING = 'ERROR_SERVER_PING';
export const errorServerPing = (error) => ({
  type: ERROR_SERVER_PING,
  error
});

export const REQUESTED_SSO_AUTHENTICATION = 'REQUESTED_SSO_AUTHENTICATION';
export const requestedSsoAuthentication = () => ({
  type: REQUESTED_SSO_AUTHENTICATION
});

export const RECEIVED_SSO_AUTHENTICATION = 'RECEIVED_SSO_AUTHENTICATION';
export const receivedSsoAuthentication = (token) => ({
  type: RECEIVED_SSO_AUTHENTICATION,
  token
});

export const ERROR_SSO_AUTHENTICATION = 'ERROR_SSO_AUTHENTICATION';
export const errorSsoAuthentication = (error) => ({
  type: ERROR_SSO_AUTHENTICATION,
  error
});
